import React from 'react';
import { findDOMNode } from 'react-dom';
import { isMobile }  from 'react-device-detect';
import { TweenLite } from 'gsap';
import 'gsap/src/uncompressed/plugins/ScrollToPlugin';

export default {
    
    reset(PartnersForm) {
        let FormNode = findDOMNode(PartnersForm);

        FormNode.querySelector('.loader').style.display = 'none';
        FormNode.querySelector('.success-msg').style.display = 'none';
        FormNode.querySelector('.error-msg').style.display = 'none';

        let labels = [...FormNode.getElementsByClassName('input__label')],
            graphics = [...FormNode.getElementsByClassName('graphic--nao')],
            formRows = [...FormNode.getElementsByClassName('form-row')];

        labels.map(item => {
            item.style.color = '#004346';
        });

        graphics.map(item => {
            item.style.stroke = '#004346';
        });

        formRows.map(item => {
            item.style.display = 'block';
        });
    },

    showLoader(PartnersForm) { 
        let FormNode = findDOMNode(PartnersForm),
            formRows = [...FormNode.getElementsByClassName('form-row')];

        formRows.map(item => {
            item.style.display = 'none';
        });
        FormNode.getElementsByClassName('loader')[0].style.display = 'block';
    },

    hideLoader(PartnersForm) {
        let FormNode = findDOMNode(PartnersForm);
        FormNode.getElementsByClassName('loader')[0].style.display = 'none';
    },

    showErrors(PartnersForm) {
        let FormNode = findDOMNode(PartnersForm),
            formRows = [...FormNode.getElementsByClassName('form-row')];

        FormNode.getElementsByClassName('loader')[0].style.display = 'none';
        formRows.map(item => {
            item.style.display = 'block';
        });
        FormNode.getElementsByClassName('error-msg')[0].style.display = 'block';
    },

    scrollUp() {
        if (isMobile) {
            let offset = document.getElementById('partners-anchor').offsetTop;

            TweenLite.to(window, 0.5, {scrollTo: offset});
        }
    }

}


// WEBPACK FOOTER //
// ./resources/assets/js/forms/PartnersForm/animations.js